import { gql } from "@apollo/client";

const FAQ_FIELDS = `
  id
  tenantId
  question
  answer
  sortOrder
  showOnFaqPage
  createdAt
  updatedAt
`;

export const CREATE_FAQ = gql`
  mutation CreateFaq(
    $question: String!
    $answer: String
    $sortOrder: Int
    $showOnFaqPage: Boolean
  ) {
    createFaq(
      question: $question
      answer: $answer
      sortOrder: $sortOrder
      showOnFaqPage: $showOnFaqPage
    ) {
      ${FAQ_FIELDS}
    }
  }
`;

export const UPDATE_FAQ = gql`
  mutation UpdateFaq(
    $id: String!
    $question: String
    $answer: String
    $sortOrder: Int
    $showOnFaqPage: Boolean
  ) {
    updateFaq(
      id: $id
      question: $question
      answer: $answer
      sortOrder: $sortOrder
      showOnFaqPage: $showOnFaqPage
    ) {
      ${FAQ_FIELDS}
    }
  }
`;

export const DELETE_FAQ = gql`
  mutation DeleteFaq($id: String!) {
    deleteFaq(id: $id) {
      id
    }
  }
`;
